// ════════════════════════════════════════════════════════════════════════
//  Schuljahr
//
//  Format wie in der Datenbank: "2026/27". Die Grenze liegt am 1. August, und
//  zwar in Europe/Berlin – nicht in der Zeitzone des Browsers und nicht in UTC.
//  Sonst schlägt das Dashboard einer Lehrkraft am 31. Juli abends schon das
//  nächste Schuljahr vor.
// ════════════════════════════════════════════════════════════════════════

/** Datumsteile in Europe/Berlin, unabhängig von der Zeitzone des Geräts. */
function berlinParts(instant: Date): { year: number; month: number } {
  const parts = new Intl.DateTimeFormat("en-CA", {
    timeZone: "Europe/Berlin",
    year: "numeric",
    month: "2-digit",
  }).formatToParts(instant);
  const fetchFn = (kind: string) =>
    Number(parts.find((t) => t.type === kind)?.value ?? "0");
  return { year: fetchFn("year"), month: fetchFn("month") };
}

export function currentSchoolYear(now: Date = new Date()): string {
  const { year, month } = berlinParts(now);
  const start = month >= 8 ? year : year - 1;
  return formatSchoolYear(start);
}

export function formatSchoolYear(beginnjahr: number): string {
  const ende = String((beginnjahr + 1) % 100).padStart(2, "0");
  return `${beginnjahr}/${ende}`;
}

/** Auswahl für das Formular: laufendes und nächstes Schuljahr. */
export function schoolYearOptions(now: Date = new Date()): string[] {
  const { year, month } = berlinParts(now);
  const start = month >= 8 ? year : year - 1;
  return [formatSchoolYear(start), formatSchoolYear(start + 1)];
}
